import { logUnhandledrejectionAndOnerror } from '@fiverr-private/obs';

logUnhandledrejectionAndOnerror();
